module.exports = __webpack_public_path__ + "static/media/celebration.88dc4699.svg";